export default __webpack_public_path__ + "static/media/gallery20.218ba58b.webp";